import * as React from "react"
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { send_authorized_request } from "../../../Constants/cognito";
import { AXIOS_API_INSTANCE } from "../../../Constants";
import { Box } from "@mui/material";
import { MetricLoading, MetricSingleValue, MetricTopLeft, MetricTopRight } from "./MetricComponents";

export default function ServiceOrdersCreated({ selectedLocations, days_back = 30, showLocationName = true }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = React.useState(false)
    const [data, setData] = React.useState({})
    const [comparisonData, setComparisonData] = React.useState({})

    const getData = (location_ids) => {
        if (!location_ids || location_ids.length === 0) {
            return
        }
        setIsLoading(true)
        const start_datetime = dayjs().subtract(days_back, 'day').startOf('day')
        const end_datetime = dayjs().startOf('day')
        send_authorized_request(() =>
            Promise.all([
                AXIOS_API_INSTANCE.get("reports/metrics/serviceorders_created", {
                    params: {
                        start_datetime: start_datetime.toISOString(),
                        end_datetime: end_datetime.toISOString(),
                        location_ids: location_ids
                    },
                }).then((data) => {
                    setData(data.data.data)
                }).catch((error) => {
                    console.log(error)
                    enqueueSnackbar(`Failed to load data <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                }),
                AXIOS_API_INSTANCE.get("reports/metrics/serviceorders_created", {
                    params: {
                        start_datetime: start_datetime.subtract(days_back, 'day').startOf('day').toISOString(),
                        end_datetime: start_datetime.toISOString(),
                        location_ids: location_ids
                    },
                }).then((data) => {
                    setComparisonData(data.data.data)
                }).catch((error) => {
                    console.log(error)
                    enqueueSnackbar(`Failed to load data <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            ]).finally(() => setIsLoading(false))
        )
    }

    React.useEffect(() => {
        getData(selectedLocations.map((x) => x.id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLocations, days_back])

    return (
        <React.Fragment>
            <Box sx={{ alignSelf: 'flex-start' }}>
                <h3>Service Orders Created</h3>
            </Box>
            {selectedLocations.length > 0 && showLocationName &&
                <MetricTopLeft>{selectedLocations.length > 1 ? 'Multiple Locations' : selectedLocations?.[0]?.name}</MetricTopLeft>
            }
            <MetricTopRight>Last {days_back} Days</MetricTopRight>
            <MetricLoading isLoading={isLoading} />
            {!isLoading &&
                <MetricSingleValue
                    value={data?.count ?? 0}
                    comparisonValue={comparisonData?.count}
                />
            }
        </React.Fragment>
    )
}